import { inject, Injectable } from '@angular/core';
import { EntityPermissionType, SystemEntity } from '@wdx/shared/utils';
import {
    ActivityfileIdPermissionsApiService,
    ActivityIdPermissionsApiService,
    AdviserIdPermissionsApiService,
    AmlreportIdPermissionsApiService,
    AmlriskIdPermissionsApiService,
    AnswerIdPermissionsApiService,
    AnswertypeIdPermissionsApiService,
    AppendixappIdPermissionsApiService,
    AppendixcalculationIdPermissionsApiService,
    AppendixlayoutIdPermissionsApiService,
    AppendixschemaIdPermissionsApiService,
    AppointmentIdPermissionsApiService,
    ArticledistributionIdPermissionsApiService,
    ArticleIdPermissionsApiService,
    AuditeventIdPermissionsApiService,
    BankaccountIdPermissionsApiService,
    BenchmarkIdPermissionsApiService,
    BlockIdPermissionsApiService,
    CampaignIdPermissionsApiService,
    CampaignresponseIdPermissionsApiService,
    CaseIdPermissionsApiService,
    ChannelIdPermissionsApiService,
    ClientIdPermissionsApiService,
    ClientproductallocationIdPermissionsApiService,
    ClientproductfeeIdPermissionsApiService,
    ClientproductIdPermissionsApiService,
    ClientproductrelationshipIdPermissionsApiService,
    ConstructIdPermissionsApiService,
    CountryassociationIdPermissionsApiService,
    CountryIdPermissionsApiService,
    CurrencyIdPermissionsApiService,
    DocumentIdPermissionsApiService,
    DocumentrequirementIdPermissionsApiService,
    DocumentrequirementtypeIdPermissionsApiService,
    DocumenttemplateIdPermissionsApiService,
    DocumenttypeIdPermissionsApiService,
    EdsmessagebatchIdPermissionsApiService,
    EdsmessageIdPermissionsApiService,
    ElectronicaddressIdPermissionsApiService,
    ElectronicbankingaddressIdPermissionsApiService,
    EmailIdPermissionsApiService,
    EmploymenthistoryIdPermissionsApiService,
    EngagementIdPermissionsApiService,
    EntityattributemetadataIdPermissionsApiService,
    EntitymetadataIdPermissionsApiService,
    EnvelopeIdPermissionsApiService,
    EventIdPermissionsApiService,
    EventparticipationIdPermissionsApiService,
    ExportIdPermissionsApiService,
    ExternalbankaccountIdPermissionsApiService,
    ExternaltaskIdPermissionsApiService,
    ExternaluserIdPermissionsApiService,
    FavouriteIdPermissionsApiService,
    FeestructureIdPermissionsApiService,
    FinancialrecordsubtypeIdPermissionsApiService,
    FormfieldmetadataIdPermissionsApiService,
    FormfunctionmetadataIdPermissionsApiService,
    FormmetadataIdPermissionsApiService,
    GoalIdPermissionsApiService,
    GoaltypeIdPermissionsApiService,
    HistoryIdPermissionsApiService,
    IdentitycheckIdPermissionsApiService,
    IdentitycheckresultIdPermissionsApiService,
    ImportIdPermissionsApiService,
    ImportlogIdPermissionsApiService,
    InsiderhistoryIdPermissionsApiService,
    InsuranceaccountIdPermissionsApiService,
    IntermediaryIdPermissionsApiService,
    InvestmentaccountIdPermissionsApiService,
    JobIdPermissionsApiService,
    KycreportIdPermissionsApiService,
    LeadIdPermissionsApiService,
    LendingaccountIdPermissionsApiService,
    LetterIdPermissionsApiService,
    ListIdPermissionsApiService,
    ListmemberIdPermissionsApiService,
    ListtypeIdPermissionsApiService,
    MailinginstructionIdPermissionsApiService,
    MandategroupIdPermissionsApiService,
    MandateIdPermissionsApiService,
    MessageIdPermissionsApiService,
    NationalidentifierIdPermissionsApiService,
    NoteIdPermissionsApiService,
    NotificationIdPermissionsApiService,
    NudgeIdPermissionsApiService,
    NudgetypeIdPermissionsApiService,
    ObjectiveIdPermissionsApiService,
    OpportunityIdPermissionsApiService,
    OpportunityproductIdPermissionsApiService,
    OrganisationIdPermissionsApiService,
    PartyIdPermissionsApiService,
    PartyroleIdPermissionsApiService,
    PartysystemconnectionIdPermissionsApiService,
    PendingchangeIdPermissionsApiService,
    PensionaccountIdPermissionsApiService,
    PersonIdPermissionsApiService,
    PhoneaddressIdPermissionsApiService,
    PhonecallIdPermissionsApiService,
    PortfolioIdPermissionsApiService,
    PostaladdressIdPermissionsApiService,
    ProductcategoryIdPermissionsApiService,
    ProductcriteriaIdPermissionsApiService,
    ProductcriteriatypeIdPermissionsApiService,
    ProductfeeIdPermissionsApiService,
    ProductgroupIdPermissionsApiService,
    ProductIdPermissionsApiService,
    ProductlineassociationIdPermissionsApiService,
    ProductlineIdPermissionsApiService,
    ProductproviderIdPermissionsApiService,
    ProductrecommendationIdPermissionsApiService,
    ProducttypeIdPermissionsApiService,
    ProjectIdPermissionsApiService,
    ProjecttemplateIdPermissionsApiService,
    ProjecttemplatetaskIdPermissionsApiService,
    ProtectedfieldgroupIdPermissionsApiService,
    ProtectionaccountIdPermissionsApiService,
    QistatusIdPermissionsApiService,
    QueueitemIdPermissionsApiService,
    QueuestatusIdPermissionsApiService,
    RegionIdPermissionsApiService,
    RelationshipIdPermissionsApiService,
    ReportIdPermissionsApiService,
    ReportrequestIdPermissionsApiService,
    RisklevelIdPermissionsApiService,
    RiskprofileanswerIdPermissionsApiService,
    RiskprofilequestionIdPermissionsApiService,
    RolesubtypeIdPermissionsApiService,
    RoletypeIdPermissionsApiService,
    SalutationIdPermissionsApiService,
    ScheduledjobIdPermissionsApiService,
    ServicetypeIdPermissionsApiService,
    SessionIdPermissionsApiService,
    SignatoryIdPermissionsApiService,
    SocialaddressIdPermissionsApiService,
    SystemlogIdPermissionsApiService,
    TagIdPermissionsApiService,
    TaskIdPermissionsApiService,
    TeamIdPermissionsApiService,
    TimebookingIdPermissionsApiService,
    TransactionevidenceIdPermissionsApiService,
    TransactionIdPermissionsApiService,
    UnitgroupIdPermissionsApiService,
    UnitIdPermissionsApiService,
    UserIdPermissionsApiService,
    WealthmanagementaccountIdPermissionsApiService,
    WebhookIdPermissionsApiService,
    WebhooklogIdPermissionsApiService,
    WorkflowIdPermissionsApiService,
    WorkflowlogIdPermissionsApiService,
    WorkitemIdPermissionsApiService,
} from '../services';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntityIdPermissionsService {
    private noApiServiceFallback = (systemEntity: SystemEntity) => ({
        get: (id: string) => {
            console.error(
                `${systemEntity} does not have an operation API service. Returning empty EntityPermissions.`,
            );
            return of([] as EntityPermissionType[]);
        },
    });

    private serviceMap: Record<
        SystemEntity,
        {
            get: (id: string) => Observable<EntityPermissionType[]>;
        }
    > = {
        [SystemEntity.Activity]: inject(ActivityIdPermissionsApiService),
        [SystemEntity.ActivityFile]: inject(
            ActivityfileIdPermissionsApiService,
        ),
        [SystemEntity.ActivityParty]: this.noApiServiceFallback(
            SystemEntity.ActivityParty,
        ),
        [SystemEntity.Adviser]: inject(AdviserIdPermissionsApiService),
        [SystemEntity.AmlReport]: inject(AmlreportIdPermissionsApiService),
        [SystemEntity.AmlRisk]: inject(AmlriskIdPermissionsApiService),
        [SystemEntity.Answer]: inject(AnswerIdPermissionsApiService),
        [SystemEntity.AnswerType]: inject(AnswertypeIdPermissionsApiService),
        [SystemEntity.AppStatus]: this.noApiServiceFallback(
            SystemEntity.AppStatus,
        ),
        [SystemEntity.AppendixApp]: inject(AppendixappIdPermissionsApiService),
        [SystemEntity.AppendixCalculation]: inject(
            AppendixcalculationIdPermissionsApiService,
        ),
        [SystemEntity.AppendixEntry]: this.noApiServiceFallback(
            SystemEntity.AppendixEntry,
        ),
        [SystemEntity.AppendixLayout]: inject(
            AppendixlayoutIdPermissionsApiService,
        ),
        [SystemEntity.AppendixSchema]: inject(
            AppendixschemaIdPermissionsApiService,
        ),
        [SystemEntity.Appointment]: inject(AppointmentIdPermissionsApiService),
        [SystemEntity.Article]: inject(ArticleIdPermissionsApiService),
        [SystemEntity.ArticleDistribution]: inject(
            ArticledistributionIdPermissionsApiService,
        ),
        [SystemEntity.AuditEvent]: inject(AuditeventIdPermissionsApiService),
        [SystemEntity.BankAccount]: inject(BankaccountIdPermissionsApiService),
        [SystemEntity.Benchmark]: inject(BenchmarkIdPermissionsApiService),
        [SystemEntity.Block]: inject(BlockIdPermissionsApiService),
        [SystemEntity.Campaign]: inject(CampaignIdPermissionsApiService),
        [SystemEntity.CampaignResponse]: inject(
            CampaignresponseIdPermissionsApiService,
        ),
        [SystemEntity.Case]: inject(CaseIdPermissionsApiService),
        [SystemEntity.CaseTeamMember]: this.noApiServiceFallback(
            SystemEntity.CaseTeamMember,
        ),
        [SystemEntity.CaseType]: this.noApiServiceFallback(
            SystemEntity.CaseType,
        ),
        [SystemEntity.Channel]: inject(ChannelIdPermissionsApiService),
        [SystemEntity.Client]: inject(ClientIdPermissionsApiService),
        [SystemEntity.ClientProduct]: inject(
            ClientproductIdPermissionsApiService,
        ),
        [SystemEntity.ClientProductAccess]: this.noApiServiceFallback(
            SystemEntity.ClientProductAccess,
        ),
        [SystemEntity.ClientProductAllocation]: inject(
            ClientproductallocationIdPermissionsApiService,
        ),
        [SystemEntity.ClientProductAssociation]: this.noApiServiceFallback(
            SystemEntity.ClientProductAssociation,
        ),
        [SystemEntity.ClientProductFee]: inject(
            ClientproductfeeIdPermissionsApiService,
        ),
        [SystemEntity.ClientProductGroup]: this.noApiServiceFallback(
            SystemEntity.ClientProductGroup,
        ),
        [SystemEntity.ClientProductRelationship]: inject(
            ClientproductrelationshipIdPermissionsApiService,
        ),
        [SystemEntity.Comment]: this.noApiServiceFallback(SystemEntity.Comment),
        [SystemEntity.Construct]: inject(ConstructIdPermissionsApiService),
        [SystemEntity.ContactPoint]: this.noApiServiceFallback(
            SystemEntity.ContactPoint,
        ),
        [SystemEntity.Country]: inject(CountryIdPermissionsApiService),
        [SystemEntity.CountryAssociation]: inject(
            CountryassociationIdPermissionsApiService,
        ),
        [SystemEntity.CreditAccount]: this.noApiServiceFallback(
            SystemEntity.CreditAccount,
        ),
        [SystemEntity.Currency]: inject(CurrencyIdPermissionsApiService),
        [SystemEntity.DataLock]: this.noApiServiceFallback(
            SystemEntity.DataLock,
        ),
        [SystemEntity.DmsDocument]: this.noApiServiceFallback(
            SystemEntity.DmsDocument,
        ),
        [SystemEntity.Document]: inject(DocumentIdPermissionsApiService),
        [SystemEntity.DocumentAssociation]: this.noApiServiceFallback(
            SystemEntity.DocumentAssociation,
        ),
        [SystemEntity.DocumentRequirement]: inject(
            DocumentrequirementIdPermissionsApiService,
        ),
        [SystemEntity.DocumentRequirementType]: inject(
            DocumentrequirementtypeIdPermissionsApiService,
        ),
        [SystemEntity.DocumentTemplate]: inject(
            DocumenttemplateIdPermissionsApiService,
        ),
        [SystemEntity.DocumentType]: inject(
            DocumenttypeIdPermissionsApiService,
        ),
        [SystemEntity.EdsMessage]: inject(EdsmessageIdPermissionsApiService),
        [SystemEntity.EdsMessageBatch]: inject(
            EdsmessagebatchIdPermissionsApiService,
        ),
        [SystemEntity.ElectronicAddress]: inject(
            ElectronicaddressIdPermissionsApiService,
        ),
        [SystemEntity.ElectronicBankingAddress]: inject(
            ElectronicbankingaddressIdPermissionsApiService,
        ),
        [SystemEntity.Email]: inject(EmailIdPermissionsApiService),
        [SystemEntity.EmploymentHistory]: inject(
            EmploymenthistoryIdPermissionsApiService,
        ),
        [SystemEntity.Engagement]: inject(EngagementIdPermissionsApiService),
        [SystemEntity.EntityAttributeMetadata]: inject(
            EntityattributemetadataIdPermissionsApiService,
        ),
        [SystemEntity.EntityMetadata]: inject(
            EntitymetadataIdPermissionsApiService,
        ),
        [SystemEntity.Envelope]: inject(EnvelopeIdPermissionsApiService),
        [SystemEntity.Event]: inject(EventIdPermissionsApiService),
        [SystemEntity.EventParticipation]: inject(
            EventparticipationIdPermissionsApiService,
        ),
        [SystemEntity.Export]: inject(ExportIdPermissionsApiService),
        [SystemEntity.ExternalBankAccount]: inject(
            ExternalbankaccountIdPermissionsApiService,
        ),
        [SystemEntity.ExternalBankAccountAssociation]:
            this.noApiServiceFallback(
                SystemEntity.ExternalBankAccountAssociation,
            ),
        [SystemEntity.ExternalTask]: inject(
            ExternaltaskIdPermissionsApiService,
        ),
        [SystemEntity.ExternalUser]: inject(
            ExternaluserIdPermissionsApiService,
        ),
        [SystemEntity.Favourite]: inject(FavouriteIdPermissionsApiService),
        [SystemEntity.FeeStructure]: inject(
            FeestructureIdPermissionsApiService,
        ),
        [SystemEntity.Feed]: this.noApiServiceFallback(SystemEntity.Feed),
        [SystemEntity.FeedNudge]: this.noApiServiceFallback(
            SystemEntity.FeedNudge,
        ),
        [SystemEntity.FileIndex]: this.noApiServiceFallback(
            SystemEntity.FileIndex,
        ),
        [SystemEntity.FinancialRecord]: this.noApiServiceFallback(
            SystemEntity.FinancialRecord,
        ),
        [SystemEntity.FinancialRecordSubType]: inject(
            FinancialrecordsubtypeIdPermissionsApiService,
        ),
        [SystemEntity.FormData]: this.noApiServiceFallback(
            SystemEntity.FormData,
        ),
        [SystemEntity.FormFieldMetadata]: inject(
            FormfieldmetadataIdPermissionsApiService,
        ),
        [SystemEntity.FormFunctionMetadata]: inject(
            FormfunctionmetadataIdPermissionsApiService,
        ),
        [SystemEntity.FormMetadata]: inject(
            FormmetadataIdPermissionsApiService,
        ),
        [SystemEntity.GeneratedDocument]: this.noApiServiceFallback(
            SystemEntity.GeneratedDocument,
        ),
        [SystemEntity.Goal]: inject(GoalIdPermissionsApiService),
        [SystemEntity.GoalType]: inject(GoaltypeIdPermissionsApiService),
        [SystemEntity.History]: inject(HistoryIdPermissionsApiService),
        [SystemEntity.IdentityCheck]: inject(
            IdentitycheckIdPermissionsApiService,
        ),
        [SystemEntity.IdentityCheckResult]: inject(
            IdentitycheckresultIdPermissionsApiService,
        ),
        [SystemEntity.IdentityMap]: this.noApiServiceFallback(
            SystemEntity.IdentityMap,
        ),
        [SystemEntity.Import]: inject(ImportIdPermissionsApiService),
        [SystemEntity.ImportLog]: inject(ImportlogIdPermissionsApiService),
        [SystemEntity.InsiderHistory]: inject(
            InsiderhistoryIdPermissionsApiService,
        ),
        [SystemEntity.InsuranceAccount]: inject(
            InsuranceaccountIdPermissionsApiService,
        ),
        [SystemEntity.Intermediary]: inject(
            IntermediaryIdPermissionsApiService,
        ),
        [SystemEntity.InvestmentAccount]: inject(
            InvestmentaccountIdPermissionsApiService,
        ),
        [SystemEntity.Job]: inject(JobIdPermissionsApiService),
        [SystemEntity.KanbanStage]: this.noApiServiceFallback(
            SystemEntity.KanbanStage,
        ),
        [SystemEntity.KanbanType]: this.noApiServiceFallback(
            SystemEntity.KanbanType,
        ),
        [SystemEntity.KycReport]: inject(KycreportIdPermissionsApiService),
        [SystemEntity.Lead]: inject(LeadIdPermissionsApiService),
        [SystemEntity.LendingAccount]: inject(
            LendingaccountIdPermissionsApiService,
        ),
        [SystemEntity.Letter]: inject(LetterIdPermissionsApiService),
        [SystemEntity.List]: inject(ListIdPermissionsApiService),
        [SystemEntity.ListMember]: inject(ListmemberIdPermissionsApiService),
        [SystemEntity.ListType]: inject(ListtypeIdPermissionsApiService),
        [SystemEntity.MailingInstruction]: inject(
            MailinginstructionIdPermissionsApiService,
        ),
        [SystemEntity.Mandate]: inject(MandateIdPermissionsApiService),
        [SystemEntity.MandateGroup]: inject(
            MandategroupIdPermissionsApiService,
        ),
        [SystemEntity.Message]: inject(MessageIdPermissionsApiService),
        [SystemEntity.NationalIdentifier]: inject(
            NationalidentifierIdPermissionsApiService,
        ),
        [SystemEntity.Note]: inject(NoteIdPermissionsApiService),
        [SystemEntity.Notification]: inject(
            NotificationIdPermissionsApiService,
        ),
        [SystemEntity.Nudge]: inject(NudgeIdPermissionsApiService),
        [SystemEntity.NudgeLog]: this.noApiServiceFallback(
            SystemEntity.NudgeLog,
        ),
        [SystemEntity.NudgeType]: inject(NudgetypeIdPermissionsApiService),
        [SystemEntity.Objective]: inject(ObjectiveIdPermissionsApiService),
        [SystemEntity.Opportunity]: inject(OpportunityIdPermissionsApiService),
        [SystemEntity.OpportunityProduct]: inject(
            OpportunityproductIdPermissionsApiService,
        ),
        [SystemEntity.OpportunityTeamMember]: this.noApiServiceFallback(
            SystemEntity.OpportunityTeamMember,
        ),
        [SystemEntity.Organisation]: inject(
            OrganisationIdPermissionsApiService,
        ),
        [SystemEntity.Party]: inject(PartyIdPermissionsApiService),
        [SystemEntity.PartyRole]: inject(PartyroleIdPermissionsApiService),
        [SystemEntity.PartyRoleAccess]: this.noApiServiceFallback(
            SystemEntity.PartyRoleAccess,
        ),
        [SystemEntity.PartySystemConnection]: inject(
            PartysystemconnectionIdPermissionsApiService,
        ),
        [SystemEntity.PendingChange]: inject(
            PendingchangeIdPermissionsApiService,
        ),
        [SystemEntity.PensionAccount]: inject(
            PensionaccountIdPermissionsApiService,
        ),
        [SystemEntity.Person]: inject(PersonIdPermissionsApiService),
        [SystemEntity.PhoneAddress]: inject(
            PhoneaddressIdPermissionsApiService,
        ),
        [SystemEntity.PhoneCall]: inject(PhonecallIdPermissionsApiService),
        [SystemEntity.Portfolio]: inject(PortfolioIdPermissionsApiService),
        [SystemEntity.PostalAddress]: inject(
            PostaladdressIdPermissionsApiService,
        ),
        [SystemEntity.PotentialDuplicate]: this.noApiServiceFallback(
            SystemEntity.PotentialDuplicate,
        ),
        [SystemEntity.Process]: this.noApiServiceFallback(SystemEntity.Process),
        [SystemEntity.ProcessType]: this.noApiServiceFallback(
            SystemEntity.ProcessType,
        ),
        [SystemEntity.Product]: inject(ProductIdPermissionsApiService),
        [SystemEntity.ProductCategory]: inject(
            ProductcategoryIdPermissionsApiService,
        ),
        [SystemEntity.ProductCriteria]: inject(
            ProductcriteriaIdPermissionsApiService,
        ),
        [SystemEntity.ProductCriteriaType]: inject(
            ProductcriteriatypeIdPermissionsApiService,
        ),
        [SystemEntity.ProductFee]: inject(ProductfeeIdPermissionsApiService),
        [SystemEntity.ProductFinancialLink]: this.noApiServiceFallback(
            SystemEntity.ProductFinancialLink,
        ),
        [SystemEntity.ProductGroup]: inject(
            ProductgroupIdPermissionsApiService,
        ),
        [SystemEntity.ProductLine]: inject(ProductlineIdPermissionsApiService),
        [SystemEntity.ProductLineAssociation]: inject(
            ProductlineassociationIdPermissionsApiService,
        ),
        [SystemEntity.ProductProvider]: inject(
            ProductproviderIdPermissionsApiService,
        ),
        [SystemEntity.ProductRecommendation]: inject(
            ProductrecommendationIdPermissionsApiService,
        ),
        [SystemEntity.ProductType]: inject(ProducttypeIdPermissionsApiService),
        [SystemEntity.Project]: inject(ProjectIdPermissionsApiService),
        [SystemEntity.ProjectTemplate]: inject(
            ProjecttemplateIdPermissionsApiService,
        ),
        [SystemEntity.ProjectTemplateTask]: inject(
            ProjecttemplatetaskIdPermissionsApiService,
        ),
        [SystemEntity.ProtectedFieldGroup]: inject(
            ProtectedfieldgroupIdPermissionsApiService,
        ),
        [SystemEntity.ProtectionAccount]: inject(
            ProtectionaccountIdPermissionsApiService,
        ),
        [SystemEntity.QiStatus]: inject(QistatusIdPermissionsApiService),
        [SystemEntity.QueueItem]: inject(QueueitemIdPermissionsApiService),
        [SystemEntity.QueueStatus]: inject(QueuestatusIdPermissionsApiService),
        [SystemEntity.RecentRecord]: this.noApiServiceFallback(
            SystemEntity.RecentRecord,
        ),
        [SystemEntity.Region]: inject(RegionIdPermissionsApiService),
        [SystemEntity.Relationship]: inject(
            RelationshipIdPermissionsApiService,
        ),
        [SystemEntity.Reminder]: this.noApiServiceFallback(
            SystemEntity.Reminder,
        ),
        [SystemEntity.Report]: inject(ReportIdPermissionsApiService),
        [SystemEntity.ReportRequest]: inject(
            ReportrequestIdPermissionsApiService,
        ),
        [SystemEntity.RiskLevel]: inject(RisklevelIdPermissionsApiService),
        [SystemEntity.RiskProfileAnswer]: inject(
            RiskprofileanswerIdPermissionsApiService,
        ),
        [SystemEntity.RiskProfileQuestion]: inject(
            RiskprofilequestionIdPermissionsApiService,
        ),
        [SystemEntity.RoleSubType]: inject(RolesubtypeIdPermissionsApiService),
        [SystemEntity.RoleType]: inject(RoletypeIdPermissionsApiService),
        [SystemEntity.Salutation]: inject(SalutationIdPermissionsApiService),
        [SystemEntity.ScheduledJob]: inject(
            ScheduledjobIdPermissionsApiService,
        ),
        [SystemEntity.ServiceType]: inject(ServicetypeIdPermissionsApiService),
        [SystemEntity.Session]: inject(SessionIdPermissionsApiService),
        [SystemEntity.Signatory]: inject(SignatoryIdPermissionsApiService),
        [SystemEntity.SocialAddress]: inject(
            SocialaddressIdPermissionsApiService,
        ),
        [SystemEntity.StockBrokingAccount]: this.noApiServiceFallback(
            SystemEntity.StockBrokingAccount,
        ),
        [SystemEntity.SystemLog]: inject(SystemlogIdPermissionsApiService),
        [SystemEntity.Tag]: inject(TagIdPermissionsApiService),
        [SystemEntity.Task]: inject(TaskIdPermissionsApiService),
        [SystemEntity.Team]: inject(TeamIdPermissionsApiService),
        [SystemEntity.TeamMember]: this.noApiServiceFallback(
            SystemEntity.TeamMember,
        ),
        [SystemEntity.TimeBooking]: inject(TimebookingIdPermissionsApiService),
        [SystemEntity.Transaction]: inject(TransactionIdPermissionsApiService),
        [SystemEntity.TransactionEvidence]: inject(
            TransactionevidenceIdPermissionsApiService,
        ),
        [SystemEntity.Unit]: inject(UnitIdPermissionsApiService),
        [SystemEntity.UnitGroup]: inject(UnitgroupIdPermissionsApiService),
        [SystemEntity.User]: inject(UserIdPermissionsApiService),
        [SystemEntity.UserDashboard]: this.noApiServiceFallback(
            SystemEntity.UserDashboard,
        ),
        [SystemEntity.UserLogin]: this.noApiServiceFallback(
            SystemEntity.UserLogin,
        ),
        [SystemEntity.UserView]: this.noApiServiceFallback(
            SystemEntity.UserView,
        ),
        [SystemEntity.ViewTile]: this.noApiServiceFallback(
            SystemEntity.ViewTile,
        ),
        [SystemEntity.WealthManagementAccount]: inject(
            WealthmanagementaccountIdPermissionsApiService,
        ),
        [SystemEntity.WebHook]: inject(WebhookIdPermissionsApiService),
        [SystemEntity.WebHookLog]: inject(WebhooklogIdPermissionsApiService),
        [SystemEntity.WorkItem]: inject(WorkitemIdPermissionsApiService),
        [SystemEntity.Workflow]: inject(WorkflowIdPermissionsApiService),
        [SystemEntity.WorkflowLog]: inject(WorkflowlogIdPermissionsApiService),
    };

    get(
        entityType: SystemEntity,
        id: string,
    ): Observable<EntityPermissionType[]> {
        if (!this.serviceMap[entityType]) {
            return this.noApiServiceFallback(entityType).get(id);
        }
        return this.typedApiService(entityType).get(id);
    }

    hasTypeService(entityType: SystemEntity): boolean {
        return !!this.serviceMap[entityType];
    }

    private typedApiService(entityType: SystemEntity) {
        return this.serviceMap[entityType] as {
            get: (id: string) => Observable<EntityPermissionType[]>;
        };
    }
}
